import { isMrPreview } from '@satellite/../nova/core';

// initial state
const state = {
  isAllowed: false
};

// getters
const getters = {
  isAllowed(state) {
    return state.isAllowed;
  },
  isMrPreview(state) {
    return isMrPreview(state.me);
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  setMe(state, me) {
    state.me = me;
    state.isAllowed = Boolean(state.carrierViewAllowedUserRoles.includes(me.role));
    // pushing user info to dataLayer
    this.$app.util.pushMeToDataLayer(me);
  },
  setIsAllowed(state, isAllowed) {
    state.isAllowed = isAllowed;
  }
};

export default {
  namespaced: true,
  name: 'Auth',
  state,
  getters,
  actions,
  mutations
};
